const ORB_MOUNT_SELECTOR = '.orb-chat-mount'
const CHAT_SECTION_SELECTOR = 'section[class^="Frame"]'
const ORB_NAV_SELECTOR = 'nav[class*="HeaderRoot-"]'
const LAUNCHER_SELECTOR = '.orb-chat-mount [class^=LauncherRoot-]'

export function onMeyaMounted(callback) {
  if (document.querySelector(ORB_MOUNT_SELECTOR)) {
    callback()
    return () => {}
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(ORB_MOUNT_SELECTOR)) {
      callback()
      observer.disconnect()
    }
  })
  observer.observe(document.body, { subtree: true, childList: true })

  return () => observer.disconnect()
}

export function enableLauncherLoadingFeedback({ className = 'is-loading', timeoutMs = 5000 } = {}) {
  let resetTimer = null
  let launcherEl = null
  let clickHandler = null
  let observer = null

  const reset = () => {
    if (resetTimer) {
      clearTimeout(resetTimer)
      resetTimer = null
    }
    launcherEl?.classList.remove(className)
  }

  const onClick = () => {
    if (!launcherEl) return
    launcherEl.classList.add(className)
    if (resetTimer) clearTimeout(resetTimer)
    resetTimer = setTimeout(reset, timeoutMs)
  }

  const attach = () => {
    if (clickHandler) return
    const el = document.querySelector(LAUNCHER_SELECTOR)
    if (!el) return
    launcherEl = el
    clickHandler = onClick
    el.addEventListener('click', clickHandler)
  }

  attach()
  if (!clickHandler) {
    observer = new MutationObserver(() => {
      attach()
      if (clickHandler) {
        observer.disconnect()
        observer = null
      }
    })
    observer.observe(document.body, { subtree: true, childList: true })
  }

  return {
    reset,
    stop: () => {
      observer?.disconnect()
      if (launcherEl && clickHandler) {
        launcherEl.removeEventListener('click', clickHandler)
      }
      if (resetTimer) clearTimeout(resetTimer)
    }
  }
}

export function onChatOpenClose({ onOpen, onClose } = {}) {
  let isOpen = false

  const observer = new MutationObserver(() => {
    const chatSection = document.querySelector(CHAT_SECTION_SELECTOR)

    if (chatSection && !isOpen) {
      isOpen = true
      const orbNav = document.querySelector(ORB_NAV_SELECTOR)
      if (orbNav) orbNav.dataset.transparent = 'true'
      onOpen?.()
    } else if (!chatSection && isOpen) {
      isOpen = false
      onClose?.()
    }
  })
  observer.observe(document.body, { childList: true, subtree: true, attributes: true })

  return () => observer.disconnect()
}
